import { render, staticRenderFns } from "./chat-image-upload.vue?vue&type=template&id=61817159&scoped=true&"
import script from "./chat-image-upload.vue?vue&type=script&lang=js&"
export * from "./chat-image-upload.vue?vue&type=script&lang=js&"
import style0 from "./chat-image-upload.vue?vue&type=style&index=0&id=61817159&lang=scss&scoped=true&"
import style1 from "./chat-image-upload.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61817159",
  null
  
)

export default component.exports